import { IBtiDataSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { getAddress } from '../getAddress';
import { getCianPriceRange } from '../getCianPriceRange';
import { getFloor } from './getFloor';
import { getRepairType } from './getRepairType';
import { getLivingConditions } from './getLivingConditions';
import { getAmenities } from './getAmenities';

export function getCalculatorUrl(offer: IOfferSchema, bti: IBtiDataSchema | null): string | null {
  if (!bti || !bti.houseData) {
    return null;
  }

  const {
    id,
    geo,
    roomsCount,
    totalArea,
    dealType,
    floorNumber,
    building,
    repairType,
    childrenAllowed,
    petsAllowed,
    hasKitchenFurniture,
    hasWasher,
    hasTv,
    hasFridge,
    hasConditioner,
  } = offer;

  const address = getAddress(geo.address);
  const cianPriceRange = getCianPriceRange(bti.houseData);

  if (!cianPriceRange || !address || !roomsCount || !totalArea) {
    return null;
  }

  const urlParams = [
    `address=${encodeURIComponent(address)}`,
    `roomsCount=${roomsCount}`,
    `totalArea=${totalArea}`,
    `offerId=${id}`,
    getFloor(floorNumber, building),
    getRepairType(repairType),
    dealType === 'rent' && 'valuationType=rent',
    dealType === 'rent' && getLivingConditions({ childrenAllowed, petsAllowed }),
    dealType === 'rent' &&
      getAmenities({
        hasKitchenFurniture,
        hasWasher,
        hasTv,
        hasFridge,
        hasConditioner,
      }),
  ]
    .filter(Boolean)
    .join('&');

  return `/kalkulator-nedvizhimosti/?${urlParams}`;
}
